import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-table-expand-btn',
  templateUrl: './table-expand-btn.component.html',
  styleUrls: ['./table-expand-btn.component.less'],
})
export class TableExpandBtnComponent implements OnInit {
  @Input() allExpanded = false;
  @Output() allExpandedChange = new EventEmitter<boolean>();
  @Input() expandSet: Set<number>;
  @Output() expandSetChange = new EventEmitter<Set<number>>();
  @Input() tableObj: any[];
  @Output() tableObjChange = new EventEmitter<any[]>();

  constructor() {}

  ngOnInit(): void {
    this.expandAll(this.allExpanded);
  }

  /**
   * Expand or collapse row
   * @param id row id
   * @param checked
   */
  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
    this.expandSetChange.emit(this.expandSet);
    this.manageExpandBtn();
  }

  /**
   * Manage collapse button display
   */
  manageExpandBtn() {
    if (this.expandSet.size === this.tableObj.length) {
      this.allExpanded = true;
    } else {
      this.allExpanded = false;
    }
    this.allExpandedChange.emit(this.allExpanded);
  }

  /**
   * Expand or collapse all rows
   * @param expand to expand or collapse
   */
  expandAll(expand: boolean) {
    this.tableObj.forEach((_, i) => {
      this.onExpandChange(i, expand);
    });
    this.tableObjChange.emit(this.tableObj);
  }
}
